import { TConfig } from 'lib/common/types/Config';

import { getQueueConfig } from './getQueueConfig';
import { TQueueFilterInteractionType } from './types';

const trimPattern = (pattern?: string | null) => pattern?.trim();

const createQueueFilterPattern = (pattern?: string | null): RegExp | null | undefined => {
  const trimmedPattern = trimPattern(pattern);

  if (!trimmedPattern) {
    return undefined;
  }

  try {
    return new RegExp(trimmedPattern);
  } catch {
    return null;
  }
};

const isQueueFilterPattern = (pattern?: RegExp | null): pattern is RegExp => pattern instanceof RegExp;

const getQueueFilterPatterns = (config: TConfig) => {
  const { queueFilters } = getQueueConfig(config);

  return Object.entries(queueFilters || {});
};

export const getQueueFilterPatternForInteractionType = ({
  config,
  interactionType,
}: {
  config: TConfig;
  interactionType: TQueueFilterInteractionType;
}): RegExp | null | undefined => {
  const { queueFilters } = getQueueConfig(config);

  return createQueueFilterPattern(queueFilters?.[interactionType]);
};

export const getOtherQueueFilterPatternsForInteractionType = ({
  config,
  interactionType,
}: {
  config: TConfig;
  interactionType: TQueueFilterInteractionType;
}): RegExp[] => {
  return getQueueFilterPatterns(config)
    // Ignore the current interaction type; we only want filters configured for other interaction types.
    .filter(([filterInteractionType]) => filterInteractionType !== interactionType)
    // Convert configured regex strings to RegExp values as early as possible.
    .map(([, pattern]) => createQueueFilterPattern(pattern))
    // Keep only valid configured patterns so blank or invalid interaction filters do not exclude queues.
    .filter(isQueueFilterPattern);
};
